<template>
  <div class="paybox">
    <headerbox></headerbox>

    <div class="main">
      <div class="container">
        <div class="money">
          <div v-if="!isMobile">
            <div v-if="isshow">
              <iframe
                :src="getIframeSrc()"
                width="100%"
                height="800px"
                frameborder="0"
                id="iframe"
              ></iframe>
            </div>
            <div v-else>
              <div v-html="htmlContent"></div>
            </div>
          </div>
          <div class="tipsbxoas">
        *预订费用支付后我们尽快为您确认订单，最终预订结果以收到确认短信为准。
      </div>
        </div>
      </div>
     
    </div>
    <footerbox></footerbox>
  </div>
</template>

<script>
import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";
import leftcheck from "components/content/Leftcheck";
import menuTitle from "components/content/menuTitle";
import moment from "moment";
import { payapi, payreslut } from "network/pay";
import { MessageBox } from "element-ui";
export default {
  name: "Pay",

  components: {
    footerbox,
    headerbox,
    hotelhead,
    leftcheck,
    leftcheck,
    menuTitle,
  },

  data() {
    return {
      orderinfro: {},
      rCheckIn: moment(new Date()).format("YYYY-MM-DD"),
      rCheckOut: moment(new Date(new Date().getTime() + 86400000)).format(
        "YYYY-MM-DD"
      ),
      htmlContent: "",
      result: null, // 用于保存支付结果
      intervalId: null, // 用于保存定时器ID
      isshow: true,
    };
  },
  mounted() {
    // this.getIframeSrc(),
    // 在组件挂载后开始心跳请求
    this.startHeartbeat();
    this.checkAndCallMobileMethod();
  },
  beforeDestroy() {
    // 在组件销毁前停止心跳请求
    this.stopHeartbeat();
  },
  methods: {
    getIframeSrc() {
      const uuid = this.$route.query.uuid;
      const paymethod = this.$route.query.paymethod;
      // 获取窗口的宽度
      const windowWidth = window.innerWidth;
 
      const isMobile = windowWidth <= 768; // 假设小于等于 768px 的宽度为手机端
      if (!isMobile) {
        if (paymethod == "wx") {
          var link123 =
            "https://csweb.xiaodianjia.cn/h5pay/native.php?uuid=" + uuid;
        } else {
          var link123 =
            "https://csweb.xiaodianjia.cn/h5pay/ys/yf_alipccode.php?uuid=" + uuid;
        }
        console.log(link123);
        return link123;
      }
      // return `http://www.tetuijiudian.com/h5pay/ys/yf_alipccode.php?uuid=${uuid}`;
    },
    checkAndCallMobileMethod() {
      const uuid = this.$route.query.uuid;
      const paymethod = this.$route.query.paymethod;
      // 获取窗口的宽度
      const windowWidth = window.innerWidth;

      // 或者使用 navigator.userAgent 检查用户代理字符串

      // 根据窗口宽度或用户代理字符串判断是否是手机端
      const isMobile = windowWidth <= 768; // 假设小于等于 768px 的宽度为手机端
      console.log(isMobile);
      if (isMobile) {
        if (paymethod == "wx") {
          const link =
            "https://www.tetuijiudian.com/h5pay/h5.php?jumpwx=1&uuid=" + uuid;
          window.location.href = link;
        } else {
          const link =
            "https://csweb.xiaodianjia.cn/h5pay/ys/yf_aliwap.php?uuid=" + uuid;
          window.location.href = link;
        }
      }
    },
    startHeartbeat() {
      // 每隔一段时间发送心跳请求
      this.intervalId = setInterval(this.PaymentResult, 2000); // 每5秒发送一次请求
    },
    stopHeartbeat() {
      // 停止心跳请求
      clearInterval(this.intervalId);
    },
    PaymentResult() {
      const that = this;
      const params = {
        uuid: this.$route.query.uuid,
      };

      payreslut(params).then((response) => {
        if (response == "ispayed") {
          that.stopHeartbeat();
          MessageBox.alert("支付成功", "提示", {
            confirmButtonText: "确定",
            type: "info",
          }).then((response) => {
            this.isshow = false;
            this.htmlContent =
              "<h1 class='page-hd-title'>支付状态</h1><div class='results' style='padding:50px; text-align:center;   display: flex;justify-content:  center;   align-items: center; font-size:20px; color:#888'>  <img src=" +
              require("assets/images/success.png").default +
              " />  <b ' style='padding:0 10px;'>支付成功</b></div>";
          });
        }
      });
    },
  },
  computed: {
    dayDifference() {
      const checkIn = moment(this.orderinfro.rCheckIn);
      const checkOut = moment(this.orderinfro.rCheckOut);
      const difference = checkOut.diff(checkIn, "days");
      return difference;
    },
    isMobile() {
      // 获取窗口的宽度
      const windowWidth = window.innerWidth;

      // 或者使用 navigator.userAgent 检查用户代理字符串

      // 根据窗口宽度或用户代理字符串判断是否是手机端
      return windowWidth <= 768; // 假设小于等于 768px 的宽度为手机端
    },
  },
};
</script>
<style lang="less" scoped>
.paybox {
  background: #f1f1f1;
  width: 100%;
  .money {
    width: 100%;
    background: #fff;
    padding: 20px 28px;
    margin-bottom: 30px;
    min-height: 300px;
   
  }
}

.tipsbxoas{
  text-align: center;
    position: relative;
    color: #999;
    font-size: 12px;
    top: -106px;
    margin-top: -100px;
}
</style>

 